import { render, staticRenderFns } from "./UserFiltersShow.vue?vue&type=template&id=dd25aef0&scoped=true&"
import script from "./UserFiltersShow.vue?vue&type=script&lang=js&"
export * from "./UserFiltersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd25aef0",
  null
  
)

export default component.exports